import { createFileRoute } from "@tanstack/react-router"

import { AssetTypeSettingsFieldsView } from "../../../../../../../../views/AssetTypeSettingsFieldsView/AssetTypeSettingsFieldsView"
import { assetTypeFieldsViewStaticData } from "../../../../../../../../views/AssetTypeSettingsFieldsView/constants"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/asset-types/$assetTypeId/fields",
)({
	component: AssetTypeSettingsFieldsView,
	staticData: assetTypeFieldsViewStaticData,
})
